// extracted by mini-css-extract-plugin
export default {"container":"SinglePlaceFormArea_container__3ORO0","hidden":"SinglePlaceFormArea_hidden__VnmyL"};